// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__31Dfs","tab":"ProcedureTabs_tab__3gmix"};